import { API_BASE_URL, authFetch } from './api';


export interface SlackBot {
  id: string;
  name: string;
  channel_id: string;
  channel_name: string | null;
  enabled: boolean;
  created_at: string;
  updated_at: string;
}

export interface CreateSlackBotPayload {
  name: string;
  channel_id: string;
  channel_name?: string;
}

export interface UpdateSlackBotPayload {
  name?: string;
  channel_id?: string;
  channel_name?: string;
  enabled?: boolean;
}

const BASE = `${API_BASE_URL}/slack-bots`;

export async function listSlackBots(): Promise<SlackBot[]> {
  const res = await authFetch(BASE);
  return res.json();
}

export async function createSlackBot(payload: CreateSlackBotPayload): Promise<SlackBot> {
  const res = await authFetch(BASE, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
  return res.json();
}

export async function updateSlackBot(id: string, payload: UpdateSlackBotPayload): Promise<SlackBot> {
  const res = await authFetch(`${BASE}/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
  return res.json();
}

export async function deleteSlackBot(id: string): Promise<{ success: boolean }> {
  const res = await authFetch(`${BASE}/${id}`, { method: 'DELETE' });
  return res.json();
}

export async function testSlackBot(id: string): Promise<{ success: boolean; message: string }> {
  const res = await authFetch(`${BASE}/${id}/test`, { method: 'POST' });
  return res.json();
}
